
import Vue from 'vue';
import VisionAuth from '@/components/VisionAuth.vue';
import { IResultDisplay } from '@/plugins/returnDisplay';
export default Vue.extend({
  name: 'ReturnDisplay',
  data: () => ({ }),
  components: {
      VisionAuth,
  },
  props: {
      article: {
          required: true,
      },
      idvAuth: {
          type: Array,
      },
  },
});
